//基础路由
export default [
  // {
  //   path: '/',
  //   name: 'layout',
  //   title: 'layout',
  //   redirect: '/main',
  //   component: () => import(/* webpackChunkName: "admin" */ '@/views/layout/Layout.vue'),
  //   children: [
  //     {
  //       path: '/main',
  //       name: 'main',
  //       title: '首页',
  //       icon: 'shouye',
  //       meta: { title: '首页' },
  //       component: () => import(/* webpackChunkName: "admin" */ '@/views/main/Main.vue'),
  //     },
  //     {
  //       path: '/chat',
  //       name: 'chat',
  //       title: '对话',
  //       icon: 'duihua',
  //       meta: { title: '对话' },
  //       component: () => import(/* webpackChunkName: "admin" */ '@/views/chat/Chat.vue'),
  //     },
  //     {
  //       path: '/visitor',
  //       name: 'visitor',
  //       icon: 'kefu',
  //       title: '访客',
  //       meta: { title: '访客' },
  //       component: () => import(/* webpackChunkName: "admin" */ '@/views/visitor/Visitor.vue'),
  //     },
  //     {
  //       path: '/customer',
  //       name: 'customer',
  //       icon: 'kefu2',
  //       title: '顾客',
  //       meta: { title: '顾客' },
  //       component: () => import(/* webpackChunkName: "admin" */ '@/views/customer/Customer.vue'),
  //     }
  //   ]
  // },
  
  {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/login/Login.vue')
  },
  {
    path: '/refresh',
    name: '空路由',
    component: () => import(/* webpackChunkName: "login" */ '@/views/refresh/Refresh.vue')
  },
  {
      path: '*',
      component: () => import(/* webpackChunkName: "login" */ '@/views/all/All.vue')
  }
]